import React, { useState } from 'react'
import Lightbox from 'react-image-lightbox'

/*
@src: 图片地址
@srcThumbnail: 缩略图地址
@alt: 图片alt
@imageStyle: 图片样式

样式已在index.js中引入
import 'react-image-lightbox/style.css'
*/
const ZoomImage = ({ src, srcThumbnail, alt, imageStyle }) => {
  const [isOpen, setIsOpen] = useState(false)
  const image = src || '/path/to/image.jpg'
  const imageThumbnail = srcThumbnail || '/path/to/imageThumbnail.jpg'

  const handleImageClick = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }
  return (
    <>
      <img className={imageStyle} src={srcThumbnail} alt={alt} onClick={handleImageClick} />

      {isOpen && (
        <Lightbox
          reactModalStyle={{ overlay: { zIndex: 9999 } }}
          mainSrc={image}
          mainSrcThumbnail={imageThumbnail}
          onCloseRequest={handleClose}
          enableZoom={true}
        />
      )}
    </>
  )
}

export default ZoomImage
